import React from 'react';

function Logo() {
  return (
    <div className="logo-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg"
     width="1.555555in" height="0.81111in"
     viewBox="0 0 280 146">
  <path fill="#ff914d" d="
  M 169.16 21.25
  Q 177.62 26.15 182.67 35.01
  C 193.58 54.16 185.41 77.94 165.71 86.76
  C 156.57 90.85 146.13 91.03 136.34 86.96
  A 0.83 0.82 26.4 0 0 135.31 87.30
  L 129.11 98.05
  A 0.60 0.60 0.0 0 0 129.33 98.87
  L 131.36 100.04
  A 1.08 1.08 0.0 0 1 131.75 101.52
  L 108.74 141.39
  A 1.29 1.28 29.1 0 1 107.02 141.88
  Q 106.09 141.38 101.17 138.53
  Q 96.26 135.68 95.36 135.11
  A 1.29 1.28 31.1 0 1 94.93 133.38
  L 118.09 93.60
  A 1.08 1.08 0.0 0 1 119.57 93.21
  L 121.60 94.39
  A 0.60 0.60 0.0 0 0 122.42 94.17
  L 128.67 83.45
  A 0.83 0.82 33.8 0 0 128.45 82.38
  C 120.05 75.91 115.02 66.76 114.03 56.80
  C 111.89 35.32 128.47 16.41 150.51 16.37
  Q 160.71 16.35 169.16 21.25
  Z
  M 180.15 53.09
  A 29.44 29.44 0.0 0 0 150.71 23.65
  A 29.44 29.44 0.0 0 0 121.27 53.09
  A 29.44 29.44 0.0 0 0 150.71 82.53
  A 29.44 29.44 0.0 0 0 180.15 53.09
  Z"
/>
<path fill="#211d1d" d="
  M 26.11 70.95
  Q 26.11 71.10 26.20 71.15
  Q 60.03 91.35 86.81 107.29
  C 95.76 112.62 88.24 124.87 79.60 119.71
  Q 25.17 87.17 8.75 77.37
  C 6.07 75.76 4.93 74.00 4.93 70.91
  C 4.92 67.82 6.07 66.06 8.75 64.46
  Q 25.17 54.64 79.59 22.09
  C 88.22 16.93 95.75 29.18 86.80 34.51
  Q 60.03 50.46 26.20 70.67
  Q 26.11 70.72 26.11 70.95
  Z"
/>
<path fill="#211d1d" d="
  M 277.44 70.92
  C 277.43 74.01 276.29 75.77 273.61 77.37
  Q 257.18 87.18 202.73 119.72
  C 194.09 124.88 186.57 112.62 195.52 107.29
  Q 222.31 91.35 256.15 71.15
  Q 256.24 71.10 256.24 70.95
  Q 256.24 70.72 256.15 70.67
  Q 222.32 50.45 195.54 34.50
  C 186.59 29.16 194.12 16.91 202.76 22.07
  Q 257.19 54.64 273.61 64.46
  C 276.29 66.06 277.44 67.82 277.44 70.92
  Z"
/>
<path fill="#ff914d" d="
  M 138.70 35.69
  Q 130.96 41.27 125.88 49.91
  A 0.18 0.18 0.0 0 1 125.55 49.79
  Q 127.68 38.43 136.23 32.27
  Q 144.78 26.10 156.23 27.69
  A 0.18 0.18 0.0 0 1 156.24 28.03
  Q 146.43 30.12 138.70 35.69
  Z"
/>
</svg>
      <div className="logo-text">
        <span className="logo-text-primary">ZipCode</span>
        <span className="logo-text-secondary">AutoFill</span>
      </div>
    </div>
  );
}

export default Logo; 